import { render, staticRenderFns } from "./TablePanel.vue?vue&type=template&id=33bda76e&scoped=true"
import script from "./TablePanel.vue?vue&type=script&lang=js"
export * from "./TablePanel.vue?vue&type=script&lang=js"
import style0 from "./TablePanel.vue?vue&type=style&index=0&id=33bda76e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bda76e",
  null
  
)

export default component.exports